import React from 'react';
import { ColumnType } from 'antd/es/table';
import { ControlMaintenanceTableRow } from 'store/ducks/Reporting/types';

const getUniqueValues = (
  data: ControlMaintenanceTableRow[],
  field: keyof ControlMaintenanceTableRow
) => {
  return Array.from(
    new Set(
      data
        .map((item) => item[field])
        .filter(
          (value) => value !== null && value !== undefined && value !== ''
        )
        .map(String)
    )
  );
};

const getFilterColumn = (
  data: ControlMaintenanceTableRow[],
  dataIndex: keyof ControlMaintenanceTableRow,
  title: string,
  width = 140
): ColumnType<ControlMaintenanceTableRow> => {
  const values = getUniqueValues(data, dataIndex);

  return {
    title,
    dataIndex,
    key: dataIndex,
    width,

    filters: values.map((value) => ({
      text: value,
      value
    })),
    filterSearch: true,

    onFilter: (value, record) => {
      const recordValue = record[dataIndex];
      return String(recordValue ?? '') === String(value);
    },
    render: (value) => value ?? '-'
  };
};

const getColumn = (
  dataIndex: keyof ControlMaintenanceTableRow,
  title: string,
  width = 140
): ColumnType<ControlMaintenanceTableRow> => ({
  title,
  dataIndex,
  key: dataIndex,
  width,
  render: (value) => value ?? '-'
});

export const processControlMaintenanceColumns = (
  data: ControlMaintenanceTableRow[] = []
): ColumnType<ControlMaintenanceTableRow>[] => {
  const hasValue = (field: keyof ControlMaintenanceTableRow) =>
    data.some(
      (item) =>
        item[field] !== null && item[field] !== undefined && item[field] !== ''
    );

  const organizationColumns: ColumnType<ControlMaintenanceTableRow>[] = [
    getFilterColumn(data, 'group_name', 'Group'),
    getFilterColumn(data, 'division_name', 'Division'),
    getFilterColumn(data, 'region_name', 'Region'),
    getFilterColumn(data, 'legal_entity_name', 'Legal Entity'),
    getFilterColumn(data, 'business_unit_name', 'Business Unit')
  ];

  const visibleOrganizationColumns = organizationColumns.filter(
    (column) =>
      typeof column.dataIndex === 'string' &&
      hasValue(column.dataIndex as keyof ControlMaintenanceTableRow)
  );

  const columns: ColumnType<ControlMaintenanceTableRow>[] = [
    // Filter
    getFilterColumn(data, 'control_name', 'Control'),
    getColumn('control_description', 'Description'),
    getColumn('owner_name', 'Owner'),
    getColumn('key_control', 'Key Control'),
    getFilterColumn(data, 'control_type_name', 'Control Type', 130),
    getColumn('design_effectiveness_name', 'Design Effectiveness'),
    getColumn('operating_effectiveness_name', 'Operating Effectiveness'),
    getColumn(
      'control_attestation_effectiveness_name',
      'Attestation Effectiveness'
    ),
    getColumn('control_effectiveness_name', 'Control Effectiveness'),
    getFilterColumn(
      data,
      'control_overall_effectiveness_name',
      'Control Overall Effectiveness'
    )
  ];

  return [...visibleOrganizationColumns, ...columns];
};
